import React from 'react';
import Styles from './credit-card-score-styles.scss';
import CircleClose2 from '../icons/circle-close2';
import BarScore from './bar-score/bar-score';
import classNames from 'classnames';
const scoreRanges = [
    { state: '300 - 579', minScore: 300, maxScore: 579, message: 'Poor', color: '#f04a4a' },
    { state: '580 - 669', minScore: 580, maxScore: 669, message: 'Fair', color: '#F48218' },
    { state: '670 - 739', minScore: 670, maxScore: 739, message: 'Good', color: '#FFB800' },
    { state: '740 - 799', minScore: 740, maxScore: 799, message: 'Very Good', color: '#85CB82' },
    { state: '800 - 850', minScore: 800, maxScore: 850, message: 'Excellent', color: '#65C702' }
];
const CreditCardScore = ({ close, score = 0 }) => {
    const getValueByScore = (score) => {
        const scoreRange = scoreRanges.find(range => score >= range.minScore && score <= range.maxScore);
        if (scoreRange) {
            return {
                state: scoreRange.state,
                message: scoreRange.message,
                color: scoreRange.color
            };
        }
        return {
            state: '0',
            message: 'Empty score',
            color: 'gray'
        };
    };
    const values = getValueByScore(score);
    return (React.createElement("div", { className: Styles.creditCardScoreComp },
        React.createElement("div", { className: Styles.content },
            React.createElement("span", { className: Styles.close },
                React.createElement(CircleClose2, { onClick: close })),
            React.createElement("span", { className: Styles.title },
                React.createElement("h2", null, "Credit Score Ranges")),
            React.createElement("div", { className: Styles.chart },
                React.createElement("h3", { className: Styles.number }, values.state),
                React.createElement("h3", { className: Styles.status }, values.message),
                React.createElement("div", { className: Styles.bar },
                    React.createElement(BarScore, { score: score }))),
            React.createElement("div", { className: Styles.data },
                React.createElement("div", { className: Styles.first },
                    React.createElement("div", { className: Styles.poor },
                        React.createElement("span", { className: classNames([Styles.ball, Styles.red]) }),
                        React.createElement("h3", null, "579 and below: Poor")),
                    React.createElement("div", { className: Styles.fair },
                        React.createElement("span", { className: classNames([Styles.ball, Styles.orange]) }),
                        React.createElement("h3", null, "580-669: Fair")),
                    React.createElement("div", { className: Styles.good },
                        React.createElement("span", { className: classNames([Styles.ball, Styles.yellow]) }),
                        React.createElement("h3", null, "670-739: Good"))),
                React.createElement("div", { className: Styles.second },
                    React.createElement("div", { className: Styles.veryGood },
                        React.createElement("span", { className: classNames([Styles.ball, Styles.greenLight]) }),
                        React.createElement("h3", null, "740-799: Very Good")),
                    React.createElement("div", { className: Styles.excellent },
                        React.createElement("span", { className: classNames([Styles.ball, Styles.greenDark]) }),
                        React.createElement("h3", null, "800-850: Excellent")))))));
};
export default CreditCardScore;
